module.exports = __webpack_public_path__ + "img/b02.b030d661.png";